// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Label{color:#333;font-size:13px;font-weight:bold}", "",{"version":3,"sources":["webpack://./src/main/js/common/components/Label/Label.styles.scss"],"names":[],"mappings":"AAAA,OACI,UAAA,CACA,cAAA,CACA,gBAAA","sourcesContent":[".Label {\n    color: #333;\n    font-size: 13px;\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
